import { render, staticRenderFns } from "./WishListPage.vue?vue&type=template&id=196e0b1d&scoped=true&"
import script from "./WishListPage.vue?vue&type=script&lang=js&"
export * from "./WishListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e0b1d",
  null
  
)

export default component.exports